<template>
  <div class="children-location-tab"
       v-if="primaryDevice && child.latest_location">

    <children-map ref="map"
                  mode="profile"
                  :child="child" />

    <our-locations-button v-if="showLocationHistory"
                     class="places-button"
                     @open="openGeofenceList" />

    <location-history v-if="showLocationHistory"
                      class="location-history"
                      :primary-device-id="primaryDevice.id"
                      :child-id="childId"
                      :device="primaryDevice"
                      @modeChange="modeChange"
                      @locationChange="createLocationTooltip" />

    <div v-if="this.$mq === 'mobile'"
         class="location-navigation-mobile">
      <router-link :to="{ name: 'locations' }"
                   class="navigation-btn btn-border" >
        <div>
          {{ $t("ourLocations") }}
        </div>
      </router-link>

      <router-link :to="{ name: 'children.single.locationHistory', params: { childId } }"
                   class="navigation-btn">
        <div>
          {{ $t("tabs.location.locationHistory") }}
        </div>
      </router-link>
    </div>
  </div>

  <location-empty-screen v-else
                         :loading="loading"
                         @retry="onRetry" />
</template>

<script>
  import ChildrenMap         from '@/components/Map/Map.vue'
  import LocationHistory     from '@/components/Child/ChildTabs/TabLocation/LocationHistory.vue'
  import LocationEmptyScreen from '@/components/Child/ChildTabs/TabLocation/LocationEmptyScreen.vue'
  import OurLocationsButton  from '@/components/Child/ChildTabs/TabLocation/OurLocationsButton'

  import analytics        from '@/services/analytics.js'

  export default {
    props: {
      childId: {
        type: String,
        required: true
      }
    },

    components: {
      ChildrenMap,
      LocationHistory,
      LocationEmptyScreen,
      OurLocationsButton
    },

    data() {
      return {
        loading: false,
        geofencePanelOpen: false
      }
    },

    created() {
      analytics.sendEvent('Loc_Tb')
      this.updateChildLocation(this.childId)
    },


    methods: {
      ...mapActions('children', {
        updateChildLocation: 'updateChildLocation'
      }),

      createLocationTooltip(child) {
        this.$refs.map.createLocationTooltip(child)
      },

      onRetry() {
        if (this.child.latest_location) {
          this.$refs.map.createLocationTooltip(this.child)
        }
      },

      openGeofenceList() {
        this.showModal('geofence')
      },

      modeChange(mode) {
        if (mode === 'now') {
          this.createLocationTooltip(this.child)
        }
      }
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById',
        getChildPrimaryDevice: 'getPrimaryDevice'
      }),

      ...mapGetters('app', {
        visibilityState: 'getVisibilityState',
        isUserInactive: 'isUserInactive'
      }),

      child() {
        return this.getChildById(this.childId)
      },

      primaryDevice() {
        return this.child.devices.find(device => device.id === this.child.primary_device_id)
      },

      location() {
        return {
          ...this.child.location,
          deviceName: this.primaryDevice.name,
          devicePlatform: this.primaryDevice.platform
        }
      },

      latestLocation() {
        return this.child.latest_location
      },

      childDevices() {
        return this.child.devices
      },

      showGeofencePanel() {
        return this.geofencePanelOpen
      },

      showLocationHistory() {
        return !this.geofencePanelOpen && this.$mq != 'mobile'
      }
    },

    watch: {
      latestLocation() {
        this.createLocationTooltip(this.child)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .children-location-tab {
    flex: 1 0;
    height: 100%;
    position: relative;

    .places-button {
      position: absolute;
      top: 16px;
      left: 16px;
    }

    .geo-panel {
      position: absolute;
      top: 0;
      left: 0;
    }

    .location-history {
      position: absolute;
      bottom: 16px;
      left: 16px;
    }
  }

  .location-navigation-mobile {
    position: absolute;
    width: 100%;
    height: 50px;

    display: flex;
    justify-content: center;
    align-items: center;

    bottom: 0;
    left: 0;

    cursor: pointer;
    background: #fff;

    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    .navigation-btn {
      height: 100%;
      width: 50%;

      display: flex;
      align-items: center;
      justify-content: center;

      color: #b9b9b9;
    }

    .btn-border {
      border-right: 1px solid #b9b9b9;
    }
  }
</style>